<template>
  <CcDownload :data="data" :show-content="false" :show-logo="false" />
</template>
<script>
import CcDownload from '../components/Download'

export default {
  name: 'ButtonDownloadBg',
  components: {
    CcDownload
  },
  provide() {
    return {
      compName: this.component.name,
      compId: this.component.id
    }
  },
  props: {
    component: {
      type: Object,
      default: () => ({})
    },
    download: {
      type: Object,
      default: () => null
    }
  },
  computed: {
    data() {
      return this.component.data || {}
    }
  }
}
</script>
